module.exports = __webpack_public_path__ + "static/media/smallDeliveryTruck_blue.49e4f50a.svg";